import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const popUpTicketPurchaseCardDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.popupTicket,
  componentType: LAYOUT_COMPONENT_TYPE.popUpTicketPurchaseCard,
  registryBlockKey: REGISTRY_BLOCK.presentation.popUpTicketPurchaseCard,
  displayOrder: 7,
  content: {
    sectionTitle: loc3('Pop-up Abend', 'Pop-up night', 'Đêm pop-up'),
    eventTitle: loc3('Grill & Vinyl Night', 'Grill & vinyl night', 'Grill & vinyl night'),
    supporting: loc3(
      'Limitierte Tickets — Essen, Drinks und Vinyl-Sets.',
      'Limited tickets — food, drinks and vinyl sets.',
      'Vé hạn chế — đồ ăn, đồ uống và set vinyl.',
    ),
    dateLabel: loc3('Sa 20. Sep · 18:00', 'Sat 20 Sep · 18:00', 'T7 20 thg 9 · 18:00'),
    price: loc3('28 €', '28 €', '28 €'),
    ctaLabel: loc3('Ticket sichern', 'Get tickets', 'Lấy vé'),
  },
  media: {},
};
